export default __webpack_public_path__ + "media/components/Courses/Course/Images/excellent-9b0fb87cae8b698961f2f10cabe8bc5b.jpg";